module.exports = __webpack_public_path__ + "media/images/common-nav/free-camping/arizona-ab6c02eb7e16ee93499ba41300037002.jpg";